import React from 'react';
import { Box, CircularProgress, Typography, Skeleton, TableRow, TableCell } from '@mui/material';

/**
 * Ortak yükleniyor göstergesi (Faz 8 UI primitifi) — ortalı spinner.
 * Mevcut `if (loading) return <CircularProgress/>` desenine drop-in alternatif.
 */
export const Loading = ({ message, sx = {} }) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
            py: 8,
            ...sx,
        }}
    >
        <CircularProgress />
        {message && (
            <Typography variant="body2" color="text.secondary">
                {message}
            </Typography>
        )}
    </Box>
);

/**
 * Tablo iskeleti — liste yüklenirken satır yerine hafif skeleton gösterir.
 * Tablo gövdesi (TableBody) içinde kullanılır.
 *
 * @param {number} rows  Skeleton satır sayısı
 * @param {number} cols  Kolon sayısı (TableHead ile aynı olmalı)
 */
export const TableSkeleton = ({ rows = 5, cols = 4 }) => (
    <>
        {Array.from({ length: rows }).map((_, r) => (
            <TableRow key={r}>
                {Array.from({ length: cols }).map((__, c) => (
                    <TableCell key={c}>
                        <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                    </TableCell>
                ))}
            </TableRow>
        ))}
    </>
);

export default Loading;
